export default "__VITE_ASSET__CvG82QCZ__"